import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useFormContext, useWatch } from 'react-hook-form'
import xIcon from 'src/assets/images/icon/icon-xImg.svg'
import { FormObjectType, JoinFormType } from 'src/types/react-hook-form'
import { KTMVNOVerifySpace } from 'src/types/api'
import {
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body3_r12,
  Noto_desc_r10,
  Noto_subheading_b18,
  Noto_subheading_r18,
} from 'src/styles/font/NotoSansKrFonts'
import { useModal } from 'src/components/Modal/provider'

export interface KTMVNOModalChildrenProps extends KTMVNOVerifySpace.Response {
  ktMVNOAttribute: Partial<FormObjectType>
  otpCertRequest: () => void
}

const KTMVNOModalChildren = ({
  Contents,
  Title,
  ktMVNOAttribute,
  otpCertRequest,
}: KTMVNOModalChildrenProps) => {
  const { closeModal } = useModal()
  const { register, setValue } = useFormContext<JoinFormType>()

  const valueKtMVNO = useWatch({ name: 'KTMVNO' })

  const handleMvnoSubmit = () => {
    otpCertRequest()
    closeModal()
  }

  const handleMvnoCancel = () => {
    closeModal()
    setValue('KTMVNO', false)
  }

  useEffect(() => {
    setValue('KTMVNO', false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <JoinKTMVNOModalContainer data-lenis-prevent-wheel data-lenis-prevent-touch>
      <CloseButton onClick={handleMvnoCancel} />
      <JoinKTMVNOModalTitle>
        KT MVNO(알뜰폰) 추가
        <br /> 약관 동의가 필요합니다.
      </JoinKTMVNOModalTitle>
      <JoinKTMVNOModalDesc>아래 약관 확인 후 동의해주세요.</JoinKTMVNOModalDesc>
      <JoinKTMVNOModalContents>
        <JoinTermsItem>
          <MvnoFormCheckboxLabel>
            {Title}
            <KtMvnoCheckbox {...register('KTMVNO', ktMVNOAttribute.register_options)} />
          </MvnoFormCheckboxLabel>
        </JoinTermsItem>
        <MvnoTermsContents>
          <p dangerouslySetInnerHTML={{ __html: Contents }} />
        </MvnoTermsContents>
      </JoinKTMVNOModalContents>
      <MvnoSubmitButton disabled={!valueKtMVNO} onClick={handleMvnoSubmit}>
        동의 및 인증번호 받기
      </MvnoSubmitButton>
    </JoinKTMVNOModalContainer>
  )
}
export default KTMVNOModalChildren

const JoinKTMVNOModalContainer = styled.section`
  display: flex;
  flex-direction: column;
  position: relative;
`
const CloseButton = styled.button`
  position: absolute;
  width: 20px;
  height: 20px;
  right: -8px;
  top: -8px;
  cursor: pointer;
  background: url(${xIcon}) no-repeat center/cover;
`

const JoinKTMVNOModalTitle = styled.strong`
  ${Noto_subheading_r18};
  display: block;
  text-align: center;
  word-break: keep-all;
  padding: 0 20px;
`

const JoinKTMVNOModalDesc = styled.p`
  ${Noto_subheading_b18};
  margin-top: 6px;
`

const JoinKTMVNOModalContents = styled.div`
  ${Noto_body1_r16};
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  height: 136px;
  border: 1px solid var(--black-10);
  border-radius: 10px;
  margin: 16px 0;
  overflow: hidden;
`

const MvnoTermsContents = styled.div`
  ${Noto_desc_r10};
  background-color: var(--black-2);
  width: 171px;
  height: 100%;
  padding: 12px;
  flex-shrink: 0;
  overflow-y: scroll;
  text-align: left;
`

const JoinTermsItem = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column;
  justify-content: center;
  padding: 0 14px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`
const KtMvnoCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--black-10);
  &::before {
    content: '';
    position: absolute;
    top: 43%;
    left: 0;
    right: 0;
    margin: auto;
    width: 7px;
    height: 14px;
    border: solid var(--white);
    border-width: 0 2px 2px 0;
    transform: translate(0, -50%) rotate(45deg);
  }
  &:checked {
    background-color: var(--brand-50);
  }
  &:checked::before {
    content: '';
    position: absolute;
    top: 43%;
    left: 0;
    right: 0;
    margin: auto;
    width: 7px;
    height: 14px;
    border: solid var(--white);
    border-width: 0 2px 2px 0;
    transform: translate(0, -50%) rotate(45deg);
  }
`

const MvnoFormCheckboxLabel = styled.label`
  ${Noto_body3_r12};
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  color: var(--black-100);
  user-select: none;
  gap: 6px;
  word-break: normal;
`

const MvnoSubmitButton = styled.button`
  height: 50px;
  width: 100%;
  border: 1px solid var(--black-20);
  border-radius: 12px;
  ${Noto_body2_b14};

  &:disabled {
    color: var(--black-30);
    background-color: var(--black-10);
    border: 1px solid var(--black-10);
    cursor: not-allowed;
  }
`
